const CHAIN_RPC = {
    1: 'https://mainnet.infura.io/v3/0e47785118b2494092b1a9a9b576c2bd',
    4: 'https://rinkeby.infura.io/v3/0e47785118b2494092b1a9a9b576c2bd',
    5: 'https://goerli.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161',
    42: 'https://kovan.infura.io/v3/0e47785118b2494092b1a9a9b576c2bd',
    56: 'https://bsc-dataseed.binance.org',
    97: 'https://data-seed-prebsc-1-s1.binance.org:8545/',
};

const CHAIN_BROWSER = {
    1: 'https://etherscan.io',
    4: 'https://rinkeby.etherscan.io',
    5: 'https://goerli.etherscan.io',
    42: 'https://kovan.etherscan.io',
    56: 'https://bscscan.com',
    97: 'https://testnet.bscscan.com',
};

const CHAIN_NAME = {
    1: 'Ethereum Chain Mainnet',
    4: 'Ethereum Chain Rinkeby',
    5: 'Ethereum Chain Goerli',
    42: 'Ethereum Chain Kovan',
    56: 'Binance Smart Chain Mainnet',
    97: 'Binance Smart Chain Testnet',
};

const CHAIN_SHORT_NAME = {
    1: 'Etherscan',
    4: 'Ethereum Chain Rinkeby',
    5: 'Goerli',
    42: 'Kovan',
    56: 'BSC',
    97: 'Binance Testnet',
};

const DefaultCostToken = {
    56: {
        name: 'USDT',
        address: '0x55d398326f99059fF775485246999027B3197955',
    },
    97: {
        name: 'LFT',
        address: '0x4f500465c89c2f8A44D1142e02338534C0c421be',
    }
}

const costTokenSymbol = {
    56: {
        '0x0000000000000000000000000000000000000000': 'BNB',
        '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56': 'BUSD',
        '0x55d398326f99059fF775485246999027B3197955': 'USDT'
    },
    97: {
        '0x0000000000000000000000000000000000000000': 'BNB',
        '0x4f500465c89c2f8A44D1142e02338534C0c421be': 'LFT',
    }
}

const MainContractsAddr = {
    56: {
        Avatar721: '0xa2b2a7774e29f13E17F95b0fc9c0722e7Be36E49',
        CartoonAvatar: '0x6f282fc910CD6eCdCcC9E0f06e6EA3e5602A24d5',
        AnswerFirst: '0x09bb16c94a3ba650b7b825bff641626bbe179e6d',
        AnswerFirstV1: '0x38EfDB800EE539AB080C005A1a316DEE85F6A7b0',
    },
}

const ContractsAddr = {
    56: {
        Avatar721: '0xa2b2a7774e29f13E17F95b0fc9c0722e7Be36E49',
        CartoonAvatar: '0xe3491ccA807E69F17C01355E4B9588C293dd1d32',
        AnswerFirst: '0xd504B4b7BC56da2f03c7A65CbCf01dC3BDa5434d',
        AnswerFirstV1: '0xd7e207359388F9cDC9C2838B4dA64770540EC646',
    },
    97: {
        Avatar721: '0x5D392622E85d7F360711604E2EEdCde82d482913',
        CartoonAvatar: '0x1794b37ea523dE5a2c5e7B9D71c1ca6464A4aE16',
        AnswerFirst: '0x474135cF4DBCAE5b93C94677520531cb528a3812',
        AnswerFirstV1: '0x707BdB443A18D04F293159390Bd119E123a865d6',
    },
};

const ApiHost = {
    dev: {
        56 : "https://pandora.lifeform.cc/lifeform_bsc_pre/api",
        97 : "https://pandora-test.lifeform.cc/lifeform_bsc_test/api",
    },
    pre: {
        56 : "https://pandora.lifeform.cc/lifeform_bsc_pre/api",
        97 : "https://pandora-test.lifeform.cc/lifeform_bsc_test/api",
    },
    prod: {
        56 : "https://pandora.lifeform.cc/lifeform_bsc_prod/api",
        97 : "https://pandora-test.lifeform.cc/lifeform_bsc_test/api",
    },
}

const ApiUrl = {
}

const ChainSymbol = {
    WToken: {
        1: 'WETH',
        4: 'WETH',
        5: 'WETH',
        42: 'WETH',
        56: 'WBNB',
        97: 'WBNB',
    },
    ZeroToken: {
        1: 'ETH',
        4: 'ETH',
        5: 'ETH',
        42: 'ETH',
        56: 'BNB',
        97: 'BNB',
    },
};

function getDefaultCostToken(chainId) {
    if (DefaultCostToken.hasOwnProperty(chainId)) {
        return DefaultCostToken[chainId];
    }
    return '';
}

function getCostTokenSymbol(chainId, addr) {
    if (costTokenSymbol.hasOwnProperty(chainId)  && costTokenSymbol[chainId].hasOwnProperty(addr)) {
        return costTokenSymbol[chainId][addr];
    }
    return '';
}

function getContractsAddr(chainId, name) {
    let env = process.env.VUE_APP_ENV;
    if(env == 'production') {
        if (MainContractsAddr.hasOwnProperty(chainId) && MainContractsAddr[chainId].hasOwnProperty(name)) {
            return MainContractsAddr[chainId][name];
        }
    }
    else {
        if (ContractsAddr.hasOwnProperty(chainId) && ContractsAddr[chainId].hasOwnProperty(name)) {
            return ContractsAddr[chainId][name];
        }
    }
    return '';
}

function getApiUrl(chainId, name) {
    let env = 'dev';
    if(process.env && process.env.VUE_APP_ENV) {
        let temp = process.env.VUE_APP_ENV;

        if(temp === 'pre') {
            env = 'pre';
        }
        else if(temp === 'production') {
            env = 'prod';
        }
    }

    if (ApiHost.hasOwnProperty(env) && ApiHost[env].hasOwnProperty(chainId) && ApiUrl.hasOwnProperty(name)) {
        return ApiHost[env][chainId] + ApiUrl[name];
    }
    return '';
}

function getChainShortName(chainId) {
    if (CHAIN_SHORT_NAME.hasOwnProperty(chainId)) {
        return CHAIN_SHORT_NAME[chainId];
    }
    return '';
}

function getChainBrowser(chainId) {
    if (CHAIN_BROWSER.hasOwnProperty(chainId)) {
        return CHAIN_BROWSER[chainId];
    }
    return '';
}

function isZeroAddress(addr) {
    return addr == '0x0000000000000000000000000000000000000000';
}


export { CHAIN_RPC, CHAIN_BROWSER, ContractsAddr, ApiHost, ApiUrl, ChainSymbol, CHAIN_NAME, CHAIN_SHORT_NAME, 
    getDefaultCostToken, getCostTokenSymbol, getContractsAddr, getApiUrl, getChainShortName, getChainBrowser, isZeroAddress };
